import { useEffect, useState } from 'react'

export const RESEND_CODE_COOLDOWN_SECONDS = 60

export function useResendCodeCooldown() {
  const [secondsRemaining, setSecondsRemaining] = useState(
    RESEND_CODE_COOLDOWN_SECONDS
  )
  const isCoolingDown = secondsRemaining > 0

  useEffect(() => {
    if (!isCoolingDown) {
      return
    }

    const intervalId = window.setInterval(() => {
      setSecondsRemaining((current) => Math.max(0, current - 1))
    }, 1000)

    return () => window.clearInterval(intervalId)
  }, [isCoolingDown])

  const restartCooldown = () => {
    setSecondsRemaining(RESEND_CODE_COOLDOWN_SECONDS)
  }

  return { secondsRemaining, restartCooldown }
}
